import gql from 'graphql-tag';

const query = gql`
  query GetActiveProducts {
    me {
      id
      diet {
        id
        accessTo
        lifetimeAccess
      }
      videoWorkout {
        accessTo
        lifetimeAccess
      }
      aiAccess {
        accessTo
        hasAccess
      }
      subscription {
        hasWorkoutAccess
      }
      activeSubscriptions {
        id
        givesAccessToDiet
        givesAccessToVideoWorkouts
        givesAccessToAi
        renewalDate
        operator
        isTrial
        isCanceled
        canceledAt
      }
    }
  }
`;

export default query;
